import { Port } from "@redux/slices/kontrolEdge/orderSlice";
import axios, { AxiosInstance, AxiosResponse } from "axios";
import { NotificationUpdatePayload } from "kontrolEdge/components/Shared/Notifications/NotificationsView";

const API_URL = process.env.REACT_APP_API_URL;

//Function to get port list data
export function fetchPortList(
  api: AxiosInstance,
  tenantId: number,
): Promise<AxiosResponse> {
return api.get(`/kontroledge/ports?tenantId=${tenantId}&includeChildServices=true`, {
});
}

//Function to get the selected port detail
export const fetchPort = (token: string,  portId: string, tenantId: number,) => {
  return axios.get(`${API_URL}/v1/kontroledge/ports/${portId}?tenantId=${tenantId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

//Function to get the subscription port details
export const fetchSubscriptionPortDetails = (token: string, portId: string, tenantId: number,) => {
  return axios.get(`${API_URL}/v1/kontroledge/ports/${portId}/subscription?tenantId=${tenantId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

//Function to get MTU details
export const fetchMTUDetails = (token: string, portId: string, tenantId: number,) => {
  return axios.get(`${API_URL}/v1/kontroledge/ports/${portId}/interface?tenantId=${tenantId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

//Function to get the status details
export const fetchStateDetails = (token: string, portId: string, tenantId: number) => {
  return axios.get(`${API_URL}/v1/kontroledge/ports/${portId}/state?tenantId=${tenantId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

//Function to get the port performance chart
export function fetchPortPerformanceAPI(
  api: AxiosInstance,
  portId: string,
  timeRange: string | undefined,
  interval: string,
  tenantId: number,
  startDate?: string,  // ISO string
  endDate?: string,    // ISO string
  maxPoints?: number
): Promise<AxiosResponse> {
const params: Record<string, unknown> = { interval };

// Use custom date range if provided, otherwise use timeRange preset
if (startDate && endDate) {
  params.start = startDate;
  params.end = endDate;
  if (maxPoints) params.maxPoints = maxPoints;
} else if (timeRange) {
  params.timeRange = timeRange;
}

return api.get(`/kontroledge/ports/${portId}/performance?tenantId=${tenantId}`, {
  params,
});
}


//Function to get the port connections
export function fetchPortConnectionsAPI(
  api: AxiosInstance,
  portId: string,
  tenantId: number
): Promise<AxiosResponse> {
return api.get(`/kontroledge/ports/${portId}/connections?tenantId=${tenantId}`, {
});
}

//Function to get the port errors
export function fetchPortErrorsAPI(
  api: AxiosInstance,
  portId: string,
  tenantId: number
): Promise<AxiosResponse> {
return api.get(`/kontroledge/ports/${portId}/crc-errors?tenantId=${tenantId}&timeRange=24h`, {
});
}


//-------------Creation orders process--------------
// Function to fetch locations
export const fetchLocationsApi = (token: string) => {
  return axios.get(`${API_URL}/v1/kontroledge/locations`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

// Function to fetch pricing
export const fetchPricingApi = (token: string) => {
  return axios.get(`${API_URL}/v1/kontroledge/pricing-plans`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

// Function to fetch pricing cross-connect
export const fetchPricingCrossConnectApi = (token: string, provider: string) => {
  return axios.get(`${API_URL}/v1/kontroledge/pricing-crossconnect?providerId=1`, {
    headers: { Authorization: `Bearer ${token}` },
    params: { zip: provider }
  });
};

//Fetch of the last mile availability
export const fetchLastMileApi = (token: string, zipCode: string) => {
  return axios.get(`${API_URL}/v1/kontroledge/lastmille/coverage?zip=03333`, {
    headers: { Authorization: `Bearer ${token}` },
    params: { zip: zipCode }
  });
};

//Function to create a port order
export const createPort = (token: string, portData: Port) => {
  return axios.post(
    `${API_URL}/v1/port`,
    portData,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};

//Functions to update and get Notifications
export function updateNotification(
  api: AxiosInstance,
  payload: NotificationUpdatePayload
): Promise<AxiosResponse> {
return api.patch(`/kontroledge/ports/`, payload);
}